import { APP_BRAND } from '@/config/brand';
import { getBrandConfig } from '@/config/brandConfig';
import { building04Icon } from '@/assets/icons';
import { AssetIcon, type AssetIconProps } from './AssetIcon';

export type BuildingSystemIconProps = Omit<AssetIconProps, 'src' | 'alt'>;

/** Building / system glyph — AG building-04, HID floor icon in composer. */
export function BuildingSystemIcon({ size = 16, className, ...props }: BuildingSystemIconProps) {
  const brandConfig = getBrandConfig();

  if (APP_BRAND === 'hid' && brandConfig.hidFloorIcon) {
    const scale = size / 16;
    return (
      <AssetIcon
        src={brandConfig.hidFloorIcon}
        width={Math.round(18 * scale)}
        height={Math.round(20 * scale)}
        className={className}
        alt=""
        aria-hidden
        {...props}
      />
    );
  }

  return <AssetIcon src={building04Icon} size={size} className={className} {...props} />;
}
